import React from 'react'
import { Card, Typography } from '@chilecompra/react-kit/components'
import { GridContainer, GridItem } from './QuoteBid.styles'

/**
 * The NoBids's component.
 */
const NoBids = () => {
  return (
    <GridContainer>
      <GridItem xs={12} sm={9}>
        <Card color="blank" elevation="4">
          <GridContainer>
            <GridItem xs={12}>
              <Typography color="black1" fontSize="20px" fontWeight="black" lineHeight="26px" variant="h3">
                Lo sentimos, no se recibieron cotizaciones para esta Compra Ágil.
              </Typography>
            </GridItem>
          </GridContainer>
        </Card>
      </GridItem>
    </GridContainer>
  )
}

export default NoBids
